"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResourceContext = void 0;
var cache_1 = require("../utils/cache");
var createResourceContext = function (_a) {
    var loadFont = _a.loadFont, loadImage = _a.loadImage;
    var fontCache = (0, cache_1.createCache)(loadFont, function (key) { return key.fontUrl; });
    var imageCache = (0, cache_1.createCache)(loadImage, function (key) { return key; });
    return {
        isFontLoaded: function (fontUrl) { return fontCache.isLoaded({ fontUrl: fontUrl, fontMetrics: null }); },
        getFont: function (fontUrl) { return fontCache.get({ fontUrl: fontUrl, fontMetrics: null }); },
        loadFont: fontCache.load,
        registerFont: fontCache.set,
        isImageLoaded: imageCache.isLoaded,
        getImage: imageCache.get,
        loadImage: imageCache.load,
        registerImage: imageCache.set,
    };
};
exports.createResourceContext = createResourceContext;
